<div class="ui-g" id="conditionAddForm">
  <div>
    <h3>{{ 'audit.addNewCondition' | translate }}</h3>

    <div class="condition-row">
      <!-- Prima colonna CONDITION TYPE-->
      <div class="condition-col" [ngClass]="{ 'disabled-container': auditRuleConditionEditId }">
        <label class="top-label" [ngClass]="{'required': true}">
          {{ 'audit.ruleConditionType' | translate }}
        </label>
        <p-dropdown
          [style]="{'width':'100%'}"
          [options]="conditionsTypeCombo"
          [filter]="false"
          [(ngModel)]="selectedRuleCondition"
          placeholder="{{ 'common.select_something' | translate }}"
          (onChange)="loadJsonSchema($event)"
          [disabled]="auditRuleConditionEditId">
        </p-dropdown>
      </div>

      <!-- Seconda colonna  NOTE-->
      <div class="condition-col  custom-condition-notes" *ngIf="show.condition_notes">
        <app-form-fields 
          [fieldSchema]="formSchema.form.condition_notes"
          [(fieldModel)]="formSchema.form.condition_notes.default"
          [optionLabel]="'label'"
          [placeholder]="'audit.selectAcm' | translate">
        </app-form-fields>
      </div>

      <!-- Terza colonna TABELLA RIFERIMENDO-->
      <div class="condition-col" *ngIf="show.condition_notes">
        <label class="top-label" for="condition_table_ref">
          {{ 'audit.conditionTableRef' | translate }}
        </label>
        <input
          style="color:#898989; width: 100%;"
          name="condition_table_ref"
          [(ngModel)]="conditionTableRef"
          #condition_table_ref
          type="text"
          pInputText
          disabled="true" />
      </div>
    </div>

    <div class="ui-g-12 ui-md-12 flex-align-center" *ngIf="show.condition_notes">
      <div class="ui-g ui-fluid">
        <div class="ui-g-6">
          <app-form-fields
            #condition_code
            *ngIf="formSchema.form.condition_code || fieldModel.condition_code"
            [fieldSchema]="formSchema.form.condition_code"
            [(fieldModel)]="fieldModel.condition_code"
            [optionLabel]="'label'"
            [placeholder]="'audit.codeCondition' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields
            #condition_description
            *ngIf="formSchema.form.condition_description || fieldModel.condition_description"
            [fieldSchema]="formSchema.form.condition_description"
            [(fieldModel)]="fieldModel.condition_description"
            [optionLabel]="'label'"
            [placeholder]="'audit.descriptionCondition' | translate">
          </app-form-fields>
        </div>
      </div>
    </div>
  </div>

  <div id="clusterCondition" *ngIf="show.cluster">
    <div class="ui-g-12 ui-md-12 flex-align-center" >
      <div class="ui-g ui-fluid">
        <div class="ui-g-3">
          <app-form-fields #cluster_boolean_condition *ngIf="formSchema.form.cluster_boolean_condition || fieldModel.cluster_boolean_condition"
            [fieldSchema]="formSchema.form.cluster_boolean_condition"
            [(fieldModel)]="fieldModel.cluster_boolean_condition"
            [optionLabel]="'label'"
            [placeholder]="'audit.select_cluster' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-9">
          <app-form-fields #cluster *ngIf="formSchema.form.cluster || fieldModel.cluster"
            [fieldSchema]="formSchema.form.cluster"
            [(fieldModel)]="fieldModel.cluster"
            [options]="effectiveClusterOption"
            [filterable]="true"
            [optionLabel]="'label'"
            [placeholder]="'audit.select_cluster' | translate">
          </app-form-fields>
        </div>
      </div>
    </div>
  </div>

  <div id="acmCondition" *ngIf="show.acm">
    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g ui-fluid">
        <div class="ui-g-6">
          <app-form-fields #acm
            [fieldSchema]="formSchema.form.acm"
            [(fieldModel)]="fieldModel.acm"
            [options]="acmList"
            [optionLabel]="'label'"
            [filterable]="true"
            (fieldModelChange)="onChangeAcm($event)"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields #acm_comparison_operator 
            [fieldSchema]="formSchema.form.acm_comparison_operator"
            [(fieldModel)]="fieldModel.acm_comparison_operator"
            [disabled]="fieldModel.acm_range">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_value 
            [fieldSchema]="formSchema.form.acm_value"
            [(fieldModel)]="fieldModel.acm_value"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate"
            [disabled]="fieldModel.acm_range">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_range
            style="display: flex;
            flex-direction: column-reverse;
            align-items: center;   margin-top: 20%;"
            [fieldSchema]="formSchema.form.acm_range"
            [(fieldModel)]="fieldModel.acm_range"
            [optionLabel]="'label'"
            (fieldModelChange)="onChangeAcmRange($event)">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_min *ngIf="fieldModel.acm_range"
            [fieldSchema]="formSchema.form.acm_min"
            [(fieldModel)]="fieldModel.acm_min"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_max *ngIf="fieldModel.acm_range"
            [fieldSchema]="formSchema.form.acm_max"
            [(fieldModel)]="fieldModel.acm_max"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
      </div>
    </div>
  </div>

  <div id="acmConditionReason" *ngIf="show.acm_reason">
    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g ui-fluid">
        <div class="ui-g-6">
          <app-form-fields #acm
            [fieldSchema]="formSchema.form.acm"
            [(fieldModel)]="fieldModel.acm"
            [options]="acmList"
            [optionLabel]="'label'"
            [filterable]="true"
            (fieldModelChange)="onChangeAcm($event)"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-6">
          <app-form-fields #acm_reason *ngIf="listReasonsFiltered.length > 0 || fieldModel.acm_reason"
            [fieldSchema]="formSchema.form.acm_reason"
            [(fieldModel)]="fieldModel.acm_reason"
            [options]="listReasonsFiltered"
            [optionLabel]="'label'"
            [filterable]="true"
            (fieldModelChange)="onChangeAcm($event)"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_comparison_operator
            [fieldSchema]="formSchema.form.acm_comparison_operator"
            [(fieldModel)]="fieldModel.acm_comparison_operator"
            [disabled]="fieldModel.acm_range">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_value
            [fieldSchema]="formSchema.form.acm_value"
            [(fieldModel)]="fieldModel.acm_value"
            [optionLabel]="'label'"
            [disabled]="fieldModel.acm_range">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_range
            style="display: flex;
            flex-direction: column-reverse;
            align-items: center;   margin-top: 20%;"
            [fieldSchema]="formSchema.form.acm_range"
            [(fieldModel)]="fieldModel.acm_range"
            (fieldModelChange)="onChangeAcmRange($event)"
            [optionLabel]="'label'">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_min *ngIf="fieldModel.acm_range"
            [fieldSchema]="formSchema.form.acm_min"
            [(fieldModel)]="fieldModel.acm_min"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
        <div class="ui-g-3">
          <app-form-fields #acm_max *ngIf="fieldModel.acm_range"
            [fieldSchema]="formSchema.form.acm_max"
            [(fieldModel)]="fieldModel.acm_max"
            [optionLabel]="'label'"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
      </div>
    </div>
  </div>

  <div id="touchpointCondition" *ngIf="show.touchpointShow">
    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g ui-fluid">
        <div class="ui-g-9">
          <app-form-fields #touchpoint
            [fieldSchema]="formSchema.form.touchpoint"
            [(fieldModel)]="fieldModel.touchpoint"
            [options]="touchpointOption"
            [optionLabel]="'label'"
            [filterable]="true"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
      
      </div>
    </div>
  </div>
  <div id="sourceSystemCondition" *ngIf="show.source_system">
    <div class="ui-g-12 ui-md-12 flex-align-center">
      <div class="ui-g ui-fluid">
        <div class="ui-g-9">
          <app-form-fields #source_system
            [fieldSchema]="formSchema.form.source_system"
            [(fieldModel)]="fieldModel.source_system"
            [options]="sourceSystemOption"
            [optionLabel]="'label'"
            [filterable]="true"
            [placeholder]="'common.select_something' | translate">
          </app-form-fields>
        </div>
      
      </div>
    </div>
  </div>

   
</div>
 <!-- Bottoni Indietro e Aggiungi -->
 <div class="buttonsContainer">
  <button
    pButton
    type="submit"
    (click)="onClickClose()"
    icon="fa fa-chevron-right"
    iconPos="right"
    class="k-generic-btn footer-btn"
    label="{{'audit.undoneAction' | translate}}">
  </button>
  <button
    pButton
    (click)="addNewCondition()"
    icon="fa fa-chevron-right"
    iconPos="right"
    type="button"
    class="k-generic-btn footer-btn"
    label="{{'audit.addCondition' | translate}}" >
  </button>

</div>


// WEBPACK FOOTER //
// ./src/app/views/audit/rules/add-rule/audit-condition/audit-new-condition/audit-new-condition.component.html